import * as _ from 'lodash';

import {
  AngularFireDatabase,
  AngularFireList
} from '@angular/fire/database';

import { CommonService } from 'src/app/services/common/common.service';
import { FirebaseUsersModel } from 'src/app/models/firebase-interfaces/firebase.users.interface';
import { Injectable } from '@angular/core';
import { MediaQueryService } from '../../media-query';
import {
  Observable
} from 'rxjs';
import { ProfileService } from './../../profile/profile.service';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class FirebaseUserService {
  usersRef: AngularFireList<FirebaseUsersModel>;
  users: Observable<FirebaseUsersModel[]>;
  usersList: FirebaseUsersModel[];
  lastSeenRef: AngularFireList<any>;
  lastSeen$;
  defaultDeviceId: string = '';
  lastSeenList: any[] = []
  loggedInUserDetails: FirebaseUsersModel;
  currentUserId: string;
  profileDetails: any;
  flag: boolean = false;

  constructor(private $db: AngularFireDatabase,
    private $common: CommonService,
    private $profileService: ProfileService,
    private $mediaQuery: MediaQueryService
  ) {
    /**
     * @description
     * getting the logged in users details and id
     */
    this.$profileService.changes.subscribe(async data => {
      if (data) {
        this.currentUserId = data.userId;
        this.profileDetails = data;
        this.lastSeenRef = this.$db.list(`lastseen/${this.currentUserId}`);
        this.getLastSeenList();
      }
    })
    this.usersRef = this.$db.list('user');
    this.defaultDeviceId = `${window.navigator.userAgent.replace(/[^a-zA-Z0-9 ]/g, '')}-${this.$mediaQuery.device}`;
    /**
     * @description
     * Observable for getting users list from firebase
     */
    this.users = this.usersRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    )
    this.users.subscribe(data => {
      if (data) {
        this.usersList = data;
      }
    })

  }

  deviceDetail(info?: number) {
    /*---1=device_token, 2=deviceId, 3=platform---*/
    switch (info) {
      case 1:
        return "123";
      case 2:
        let deviceId = window.btoa(`${window.navigator.userAgent} ${new Date().getTime()}`)
        return deviceId;
      case 3:
        return "3";
      case 4:
        return this.getTimeZone();

      case 5:
        return window.btoa('Random Device Token')
      case 6:
        return window.navigator.userAgent
    }
  }

  getTimeZone() {
    let date = new Date();
    let offset = date.getTimezoneOffset() * -1;
    return offset * 60 * 1000;
  }

  getLastSeenList() {
    this.lastSeen$ = this.lastSeenRef.snapshotChanges()
      .pipe(
        map(changes =>
          changes.map(c => ({ key: c.payload.key }))
          //  ...c.payload.val()
        )
      )
      .subscribe(data => {
        const deviceId: string = `${window.navigator.userAgent.replace(/[^a-zA-Z0-9 ]/g, '')}-${this.$mediaQuery.device}`;
        this.defaultDeviceId = deviceId;
        if (data && data.length) {
          this.lastSeenList = data;
          if (this.flag === false) {
            this.updateLastSeen(this.currentUserId, deviceId, true);
          }
          this.flag = true;
        } else {
          if (this.flag == false) {
            this.updateLastSeen(this.currentUserId, deviceId, true);
          }
          this.flag = true;
        }
      })

  }

  /**
   *
   * @param userId
   * @description
   * updates last seen of user in firebaseDB
   */
  updateLastSeen(userId: string, deviceId: string, isActive = true, inChatRoom = false): Promise<any> {
    const payload: any = {
      isActive,
      lastSeen: Date.now()
    }
    if (this.lastSeenList && this.lastSeenList.length) {
      const item = this.lastSeenList.find(item => item.key === deviceId);
      if (item && deviceId && payload) {

        return this.$db.list(`lastseen/${userId}`).update(deviceId, payload)
      } else {
        return this.$db.list(`lastseen/${userId}`).set(deviceId, payload);
      }
    } else {
      return this.$db.list(`lastseen/${userId}`).set(deviceId, payload)
    }
  }

  getDeviceRefId(userId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const msgId = this.$db.list(`/lastseen/${userId}`, (ref: any) => {
        return ref.child(userId).push().key
      })
      // return msgId.query;
      resolve(msgId.query)
    })
  }



  /**
   * @param
   * @description
   * returns a json of loggedIn user
   */
  getLoggedUser(): Promise<FirebaseUsersModel> {
    return new Promise((resolve, reject) => {
      const element: FirebaseUsersModel = this.usersList.find(el => el.userId === this.currentUserId);
      if (element) {
        resolve(element)
      } else {
        reject(element)
      }
    })
  }

  getUserFirebaseProfile(userId): Observable<any> {
    return this.$db.object(`user/${userId}`).valueChanges();
    // return new Observable((observer: Observer<any>) => {
    //   const element: FirebaseUsersModel = this.usersList.find(el => el.userId === userId);
    //   observer.next(element);
    // })
  }

  createFirebaseUser(user: FirebaseUsersModel) {
    const userDetails = this.$common.removeEmptyValueFromObject(user);
    this.usersRef.set(user.userId, userDetails);
  }
  async updateFirebaseUser(key: string, user: FirebaseUsersModel, flag?: boolean) {
    const userDetails = this.$common.removeEmptyValueFromObject(user);
    await this.usersRef.update(key, userDetails);
    // this.$db.list('lastseen)'
    // if (flag) {
    // } else {
    //   const userDetails = this.$common.removeEmptyValueFromObject(user);
    //   this.usersRef.update(key, userDetails);
    // }

  }
  async removeUserSession(user: FirebaseUsersModel): Promise<any> {
    try {
      const token = this.deviceDetail(6).toString();
      const stst = await this.$db.list(`lastseen/${user.userId}/${token}`).remove();
      return stst;
    } catch (error) {

    }
    // return new Promise((resolve,reject)=>{
    //   const userList = this.$db.list(`lastseen/${user.userId}`)
    //   userList.remove(token);
    // })


    // await this.$db.list(`lastseen/${user.userId}`).remove()
    // return await this.$db.list(`lastseen/${user.userId}`).remove({});
  }
  removeUser(key: string) {
    /**
     * @description
     * Deleting user via his firebase unique key
     */
    this.usersRef.remove(key);
  }


  async deviceIdAsync() {

  }

  //   updateLastSeen(bool isActive) async {
  //   UserModel user = await AppSharedPreference.appPref.globalUser;
  //   if (!isNullOrEmpty(user.userId)) {
  //     _fRef
  //       .child(FirebaseNodes.lastSeenNode)
  //       .child(user.userId)
  //       .child(PushNotificationsManager.deviceId)
  //       .child(FirebaseConstants.isActive)
  //       .set(isActive);
  //     if (!isActive) {
  //       _fRef
  //         .child(FirebaseNodes.lastSeenNode)
  //         .child(user.userId)
  //         .child(PushNotificationsManager.deviceId)
  //         .child(FirebaseConstants.lastSeen)
  //         .set(ServerValue.timestamp);
  //     }
  //   }
  // }


  disconnectFromFirebase() {
    this.$db.database.goOffline();
  }

  connectToFirebase() {
    this.$db.database.goOnline();
  }





}
